import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoaurbaniaonrent() {



  const cardData =
  {
    keyword: 'Pune to Goa Urbania On Rent',
    heading: 'Amruta Travels: Pune to Goa Urbania On Rent',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Pune to Goa Urbania on Rent, delivering a luxurious and comfortable travel experience for families, corporate groups, and holidaymakers. Our Force Urbania vans are perfect for the scenic Pune–Goa route, featuring plush push-back seats, strong air conditioning, ample luggage space, and smooth suspension for long-distance comfort. Whether it’s a weekend getaway, business trip, or beach holiday, our professional chauffeurs ensure a safe, punctual, and enjoyable journey. With options for 10-seater, 13-seater, and 17-seater Urbania vans, you can travel in style while enjoying the perfect balance of space and luxury. Choose Amruta Travels’ Pune to Goa Urbania Rental for a premium, hassle-free ride that makes your coastal journey unforgettable.',

    top: 'Top Places to Visit in Goa with Amruta Travels',

"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is Goa’s most vibrant and happening destination, known for its lively nightlife, beach shacks, and water sports. From parasailing and jet skiing to candlelit dinners by the shore, it offers something for everyone. Tito’s Lane and Café Mambo keep the party going till late night. Baga Beach is the heartbeat of North Goa’s coastal charm and entertainment scene."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, often called the 'Queen of Beaches,' is the largest and most popular stretch in North Goa. It attracts travelers with its golden sands, bustling markets, and adventure activities like banana rides and snorkeling. Sunsets here paint the sky in stunning colors. Calangute is Goa’s perfect blend of relaxation, fun, and seaside beauty."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, holds the mortal remains of St. Francis Xavier. Built in 1605, this baroque-style church showcases exquisite architecture and historical significance. The ornate interiors and peaceful atmosphere inspire awe among visitors. It stands as Goa’s most sacred and globally revered Christian landmark."
  },
  {
    "title": "Fort Aguada",
    "description": "Perched overlooking the Arabian Sea, Fort Aguada was built by the Portuguese in the 17th century to guard against invasions. Its iconic lighthouse and panoramic ocean views attract history lovers and photographers. The fort also offers serene sunset vistas. Fort Aguada is Goa’s majestic sentinel of history and maritime legacy."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, meaning ‘Sea of Milk,’ cascades from a height of over 300 meters amidst the lush Western Ghats. Located on the Goa-Karnataka border, it’s one of India’s tallest and most breathtaking waterfalls. Visitors enjoy jeep safaris and scenic treks through Bhagwan Mahavir Wildlife Sanctuary. Dudhsagar is Goa’s awe-inspiring natural wonder."
  },
  {
    "title": "Anjuna Flea Market",
    "description": "Anjuna Flea Market is a shopper’s paradise that comes alive every Wednesday with vibrant stalls and live music. You’ll find bohemian jewelry, handicrafts, clothes, and vintage souvenirs from around the world. The market reflects Goa’s hippie culture and artistic vibe. Anjuna Market is the colorful heartbeat of Goa’s global traveler spirit."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is famous for its crescent-shaped coastline and tranquil waters. It’s ideal for kayaking, yoga retreats, and dolphin-spotting boat rides. Colorful huts line the beach, offering a serene yet lively atmosphere. Palolem is Goa’s peaceful paradise for nature lovers and couples seeking calm amidst tropical beauty."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort gained fame from the Bollywood movie 'Dil Chahta Hai' and offers mesmerizing views of Vagator Beach and the Arabian Sea. Built in 1617, it once served as a strategic Portuguese outpost. The rugged charm and sunset vistas make it a favorite among photographers. Chapora Fort is Goa’s cinematic symbol of adventure and nostalgia."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach is one of South Goa’s oldest and most scenic beaches, stretching for over 2.5 km. It’s known for its white sands, calm waters, and laid-back atmosphere. Visitors enjoy parasailing, seafood shacks, and evening walks along the shoreline. Colva Beach represents Goa’s serene and soulful coastal essence."
  },
  {
    "title": "Se Cathedral",
    "description": "Se Cathedral, dedicated to St. Catherine of Alexandria, is one of Asia’s largest churches and a masterpiece of Portuguese-Gothic architecture. Its golden bell is among the most famous in the world. The vast interiors and serene aura make it a spiritual treasure. Se Cathedral stands as Goa’s grand emblem of faith and colonial artistry."
  }
],



   "services": [
    {
      "name": "Pune to Goa Urbania On Rent",
      "description": "Rent a comfortable Urbania van for your journey from Pune to Goa. Perfect for group travel, family trips, and corporate outings, this service offers reliable vehicles with experienced drivers for a smooth and enjoyable ride to Goa."
    },
    {
      "name": "Urbania Hire Pune to Goa",
      "description": "Urbania Hire Pune to Goa provides flexible rental options for Urbania vans, catering to all travel needs including vacations, corporate trips, and tours. Enjoy spacious seating and amenities designed for long-distance travel."
    },
    {
      "name": "Force Urbania Rental Pune to Goa",
      "description": "Force Urbania Rental Pune to Goa offers the powerful and spacious Force Urbania vans for comfortable intercity travel. Ideal for groups looking to travel together with luggage space and good legroom."
    },
    {
      "name": "AC Urbania Pune Goa",
      "description": "Travel from Pune to Goa in air-conditioned Urbania vans that provide a cool and relaxing environment, ensuring you reach your destination fresh and comfortable."
    },
    {
      "name": "Non AC Urbania Pune Goa",
      "description": "Affordable and practical non-AC Urbania vans for Pune to Goa travel. Suitable for budget-conscious travelers looking for dependable transport without compromising on space or comfort."
    },
    {
      "name": "Luxury Urbania Pune to Goa",
      "description": "Experience premium travel with Luxury Urbania vans from Pune to Goa. These vehicles come equipped with enhanced interiors and extra amenities to make your journey stylish and comfortable."
    },
    {
      "name": "Urbania Van for Goa Trip",
      "description": "Book an Urbania van specifically for your Goa trip from Pune. Designed to accommodate families, friends, and corporate groups with ample space for passengers and luggage."
    },
    {
      "name": "17 Seater Urbania Pune to Goa",
      "description": "Spacious 17-seater Urbania vans for group travel from Pune to Goa, offering ample seating capacity combined with comfort and safety for long-distance journeys."
    },
    {
      "name": "16 Seater Urbania Pune to Goa",
      "description": "Reliable 16-seater Urbania vans for seamless travel between Pune and Goa, ideal for mid-sized groups requiring efficient and comfortable transportation."
    },
    {
      "name": "Family Urbania Pune to Goa",
      "description": "Family-friendly Urbania vans equipped to make your Pune to Goa trip comfortable and enjoyable, with extra space for luggage and a smooth travel experience."
    },
    {
      "name": "Corporate Urbania Pune to Goa",
      "description": "Corporate Urbania vans for business trips and corporate tours from Pune to Goa, ensuring professional service, timely pickups, and comfortable rides."
    },
    {
      "name": "Tourist Urbania Pune to Goa",
      "description": "Tourist Urbania vans tailored for sightseeing groups and travel enthusiasts going from Pune to Goa, providing a hassle-free and enjoyable travel experience."
    },
    {
      "name": "Pune to Goa Urbania Booking",
      "description": "Easy online booking for Urbania vans traveling from Pune to Goa, offering transparent pricing, flexible schedules, and quick confirmations."
    },
    {
      "name": "Affordable Urbania Pune Goa",
      "description": "Affordable Urbania van rentals from Pune to Goa, perfect for budget travelers without sacrificing comfort or reliability."
    },
    {
      "name": "Force Urbania Hire Pune Goa",
      "description": "Force Urbania hire service for Pune to Goa routes, combining power and space for a comfortable and safe journey."
    },
    {
      "name": "Pune Goa Tour Urbania",
      "description": "Tour packages with Urbania vans from Pune to Goa that include sightseeing stops, flexible itineraries, and guided tours for groups."
    },
    {
      "name": "Urbania Outstation Pune Goa",
      "description": "Outstation Urbania van rental service for travel between Pune and Goa, ideal for both personal and corporate trips with reliable service."
    },
    {
      "name": "Urbania Travel Pune Goa",
      "description": "Convenient Urbania travel service covering the Pune to Goa route with comfortable seating, safety features, and professional drivers."
    }
  ],
  "tableData": [
    ["Pune to Goa Urbania On Rent", "Urbania Hire Pune to Goa"],
    ["Force Urbania Rental Pune to Goa", "AC Urbania Pune Goa"],
    ["Non AC Urbania Pune Goa", "Luxury Urbania Pune to Goa"],
    ["Urbania Van for Goa Trip", "17 Seater Urbania Pune to Goa"],
    ["16 Seater Urbania Pune to Goa", "Family Urbania Pune to Goa"],
    ["Corporate Urbania Pune to Goa", "Tourist Urbania Pune to Goa"],
    ["Pune to Goa Urbania Booking", "Affordable Urbania Pune Goa"],
    ["Force Urbania Hire Pune Goa", "Pune Goa Tour Urbania"],
    ["Urbania Outstation Pune Goa", "Urbania Travel Pune Goa"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Urbania On Rent",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers comfortable and reliable Urbania rental services for Pune to Goa trips, perfect for group travel along this scenic route."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans provide ample space and ergonomic seating to ensure a relaxed and enjoyable long-distance journey."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "We regularly service and sanitize our vehicles to guarantee safety and hygiene throughout your trip."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from clear pricing with no hidden charges, offering great value for your Pune to Goa travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose rental durations tailored for your Pune to Goa trip, including round trips and multi-day packages."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are skilled and familiar with the Pune to Goa route, ensuring a safe, punctual, and pleasant journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, itinerary changes, and travel assistance."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Pune to Goa Urbania rental easily online or via phone, with prompt vehicle delivery and reliable service."
  }
]























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania on rent for Pune to Goa trips?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Urbania vehicles on rent for comfortable and safe travel from Pune to Goa.',
  },
  {
    question: 'How can I book an Urbania for Pune to Goa travel with Amruta Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What amenities are available in the Urbania vehicles for Pune to Goa trips?',
    answer: 'Our Urbania vehicles come with comfortable seating, air conditioning, and essential safety features for a pleasant long-distance journey.',
  },
  {
    question: 'Are the drivers experienced in Pune to Goa routes for Urbania hires?',
    answer: 'Yes, our drivers are professional, experienced, and well-versed with the Pune to Goa route to ensure a safe and timely trip.',
  },
  {
    question: 'Can Urbania vehicles be hired for one-way or round trips between Pune and Goa?',
    answer: 'Absolutely. We offer flexible booking options for both one-way and round trips between Pune and Goa.',
  },
  {
    question: 'Is the Urbania rental service for Pune to Goa available 24×7?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Pune to Goa Urbania rentals to fit your travel plans.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Goa Urbania hires?',
    answer: 'All vehicles are sanitized thoroughly before each trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for Pune to Goa Urbania rentals?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Pune to Goa Urbania rental period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your Pune to Goa Urbania rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Kulkarni',
    feedback: 'The Pune to Goa Urbania from Amruta Travels was very comfortable. The driver knew the route well and made the trip enjoyable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Deshmukh',
    feedback: 'Great service and a smooth ride from Pune to Goa. Highly recommend Amruta Travels for long-distance Urbania rentals.',
    rating: 5,
  },
];









































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Urbania On Rent",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/24.jpg",
  "description": "Book Pune to Goa Urbania On Rent with Amruta Travels Pvt. Ltd. Offering AC and Non-AC Force Urbania vans for family trips, corporate travel, and tourist journeys. Comfortable and affordable Pune to Goa Urbania rental service.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.88",
    "ratingCount": "13560"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/pune-to-goa-urbania-on-rent"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Goa Urbania On Rent | Force Urbania Van Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Pune to Goa Urbania On Rent with Amruta Travels Pvt. Ltd. Offering AC and Non-AC Force Urbania vans for family trips, corporate travel, and tourist journeys. Reliable and affordable Pune to Goa Urbania rental service."
  />
  <meta
    name="keywords"
    content="Pune to Goa Urbania On Rent, Urbania Hire Pune to Goa, Force Urbania Rental Pune to Goa, AC Urbania Pune Goa, Non AC Urbania Pune Goa, Luxury Urbania Pune to Goa, Urbania Van for Goa Trip, 17 Seater Urbania Pune to Goa, 16 Seater Urbania Pune to Goa, Family Urbania Pune to Goa, Corporate Urbania Pune to Goa, Tourist Urbania Pune Goa, Pune to Goa Urbania Booking, Affordable Urbania Pune Goa, Force Urbania Hire Pune Goa, Pune Goa Tour Urbania, Urbania Outstation Pune Goa, Urbania Travel Pune Goa"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoaurbaniaonrent;